import { FeatureFlagKey } from '../types/FeatureFlag';
import { useAppSelector } from '../utils';
import { getFeatureValue } from '../selectors/featureSelectors';

export const useFeatureFlag = (key: FeatureFlagKey) => {
  const value = useAppSelector(state => getFeatureValue(state, { key }));
  return value;
};
